class CartGoal {
  constructor() {
    this.progressBars = document.querySelectorAll('.nf-cart-goal__progress-bar');
    this.goalContainers = document.querySelectorAll('.nf-cart-goal');
    this.init();
  }

  init() {
    this.animateProgressBars();
    this.setupQuantityWatchers();
  }

  setupQuantityWatchers() {
    // Listen for the specific cart update events that are actually dispatched
    document.addEventListener('cart:update', () => {
      this.updateProgressBar();
    });

    // Listen for quantity selector updates
    document.addEventListener('quantity-selector:update', () => {
      this.updateProgressBar();
    });

    // Fallback: listen for any cart-related changes with a small delay
    document.addEventListener('change', (event) => {
      // Check if the change is related to cart (quantity inputs, etc.)
      const target = event.target;
      if (target && target.matches && target.matches('input[type="number"], .quantity-selector input, .cart-quantity input')) {
        setTimeout(() => {
          this.updateProgressBar();
        }, 100);
      }
    });

    // Listen for clicks on remove buttons or quantity change buttons
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target && target.matches && target.matches('.cart-remove, .quantity-selector button, .cart-quantity button')) {
        setTimeout(() => {
          this.updateProgressBar();
        }, 100);
      }
    });
  }

  async updateProgressBar() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      this.goalContainers.forEach(container => {
        this.updateSingleGoal(container, cart);
      });
    } catch (error) {
      console.error('Error updating cart goal:', error);
    }
  }

  updateSingleGoal(container, cart) {
    const progressBar = container.querySelector('.nf-cart-goal__progress-bar');
    const message = container.querySelector('.nf-cart-goal__message');
    
    if (!progressBar || !message) return;

    // Get goal value from data attributes
    const goalValue = parseFloat(container.dataset.goalValue) || 50;
    const goalValueCents = goalValue * 100;
    
    let percentage, color, description;

    if (cart.total_price < goalValueCents) {
      percentage = (cart.total_price / goalValueCents) * 100;
      color = container.dataset.goalColorBefore || '#0d6efd';
      const remaining = goalValueCents - cart.total_price;
      const remainingMoney = this.formatMoney(remaining);
      const descriptionTemplate = container.dataset.goalDescriptionBefore || 'Nog [amount] tot gratis verzending!';
      description = descriptionTemplate.replace('[amount]', remainingMoney);
    } else {
      percentage = 100;
      color = container.dataset.goalColorAfter || '#198754';
      description = container.dataset.goalDescriptionAfter || 'Je hebt gratis verzending!';
    }

    // Update progress bar
    progressBar.style.width = `${percentage}%`;
    progressBar.style.backgroundColor = color;
    progressBar.setAttribute('data-width', `${percentage}%`);

    const messageText = message.querySelector('.nf-cart-goal__message-text');

    if (messageText) {
      messageText.textContent = description;
    } else {
      message.textContent = description;
    }

    if (percentage === 100) {
      message.style.color = color;
      message.style.setProperty('--nf-cart-goal-check-bg', color);
    } else {
      message.style.color = '';
      message.style.removeProperty('--nf-cart-goal-check-bg');
    }

    if (percentage === 100) {
      message.classList.add('nf-cart-goal__message--complete');
    } else {
      message.classList.remove('nf-cart-goal__message--complete');
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  animateProgressBars() {
    this.progressBars.forEach(bar => {
      const width = bar.getAttribute('data-width');
      if (width) {
        setTimeout(() => {
          if (bar instanceof HTMLElement) {
            bar.style.width = width;
          }
        }, 100);
      }
    });
  }
}

// Initialize cart goal when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CartGoal();
});

// Re-initialize when new content is loaded (but avoid multiple instances)
let cartGoalInstance = null;

document.addEventListener('cart:update', () => {
  if (!cartGoalInstance) {
    cartGoalInstance = new CartGoal();
  } else {
    cartGoalInstance.updateProgressBar();
  }
});

// Re-initialize when page becomes visible
document.addEventListener('visibilitychange', () => {
  if (!document.hidden && !cartGoalInstance) {
    cartGoalInstance = new CartGoal();
  }
}); 